import { useContext } from "react";
import { Slide } from '@mui/material';
import { CustomTabs, CustomTab } from "../../styles/style";
import DataSourceContext from "../../context/DataSourceMngContext";

const TabMainMenu = () => {
    const { tab, setTab } = useContext(DataSourceContext);

    const menuItems = [
        { value: 'data_source', label: 'Data Source' },
        { value: 'fact_sheet', label: 'Fact Sheet' },
    ];

    const handleChange = (event, newValue) => {
        setTab(newValue);
        localStorage.setItem('tab-ds', newValue);
    };

    return (
        // <Slide in={true}>
            <CustomTabs value={tab} onChange={handleChange}>
                {menuItems.map((item) => (
                    <CustomTab key={item.value} value={item.value} label={item.label} />
                ))}
            </CustomTabs>
        // </Slide>
    );
};

export default TabMainMenu;